/**
 * RGM Contests · Phase 1 — Reusable ScoringPanel.
 *
 * Presentational-only: parent owns state + persistence. Later phases
 * (Spotlight yes/maybe/no · A&R Room · weekly assignments) can reuse
 * the same component by passing a different `criteria` prop.
 */
import React from "react";

export default function ScoringPanel({ criteria = [], scale = { min: 1, max: 10 }, scores = {}, notes = "", disabled = false, onScoreChange, onNotesChange }) {
  return (
    <div className="space-y-3" data-testid="scoring-panel">
      {criteria.map((c) => {
        const v = scores[c.criterion_id];
        return (
          <div key={c.criterion_id} className="rounded border border-white/10 bg-black/30 p-3">
            <div className="flex items-center justify-between mb-1.5">
              <span className="text-xs font-bold text-white">{c.label}</span>
              <span className="text-[10px] uppercase tracking-widest text-gray-500">
                Weight ×{c.weight || 1} · {v == null ? "—" : v} / {scale.max}
              </span>
            </div>
            <input
              type="range"
              min={scale.min} max={scale.max} step={1}
              value={v == null ? scale.min : v}
              onChange={(e) => onScoreChange?.(c.criterion_id, parseInt(e.target.value, 10))}
              disabled={disabled}
              className="w-full accent-fuchsia-500"
              data-testid={`score-slider-${c.criterion_id}`}
              aria-label={`Score for ${c.label}`}
            />
            <div className="flex justify-between text-[9px] text-gray-500 mt-0.5 tabular-nums">
              <span>{scale.min}</span><span>{scale.max}</span>
            </div>
          </div>
        );
      })}
      <div>
        <label className="text-[10px] uppercase tracking-widest text-gray-400 font-bold block mb-1">Notes (optional, private)</label>
        <textarea
          value={notes} onChange={(e) => onNotesChange?.(e.target.value.slice(0, 2000))}
          rows={3} disabled={disabled} maxLength={2000}
          placeholder="Only you and admin will see these notes."
          className="w-full bg-black/40 border border-white/15 rounded p-2 text-xs text-white focus:outline-none focus:border-fuchsia-400/70 resize-y disabled:opacity-50"
          data-testid="score-notes-input"
        />
      </div>
    </div>
  );
}
